import { Button, Menu, MenuItem } from "@mui/material";
import { MouseEvent, useState } from "react";
import { useHistory } from "react-router-dom";

import { IAprovarContrato } from "./types";

interface IBotaoComMenuProps {
  rotulo: string;
  contratos: IAprovarContrato[];
  variante?: "contained" | "outlined";
}

/** Um contrato com caminho: navega direto. Vários: abre menu. Nenhum: desabilitado. */
export function BotaoComMenu({ rotulo, contratos, variante = "contained" }: IBotaoComMenuProps) {
  const history = useHistory();
  const [ancora, setAncora] = useState<HTMLElement | null>(null);
  const comCaminho = contratos.filter((a) => a.caminho !== null);

  function abrir(e: MouseEvent<HTMLElement>) {
    if (comCaminho.length === 1) history.push(comCaminho[0].caminho as string);
    else setAncora(e.currentTarget);
  }

  return (
    <>
      <Button variant={variante} onClick={abrir} disabled={comCaminho.length === 0} sx={{ alignSelf: "flex-start" }}>
        {rotulo}
      </Button>
      <Menu anchorEl={ancora} open={ancora !== null} onClose={() => setAncora(null)}>
        {comCaminho.map((a) => (
          <MenuItem
            key={a.workspaceId}
            onClick={() => {
              setAncora(null);
              history.push(a.caminho as string);
            }}
          >
            {a.rotulo}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
